import { BehaviorParameters } from 'rangeConfig/@types';
import { AccessoryAddedSystem, PartKey, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, ProductPartComponent } from '@inter-ikea-core/core';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeAllDrawerAccessoriesFromScene = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const drawerAccessories = coreApi.entities
    .getByProductTypes([ProductType.PAX_DRAWER_BOX_ASM, ProductType.PAX_DRAWER_MAT])
    .filter(
      accessory =>
        accessory.getComponent<ProductPartComponent>(ComponentIds.PRODUCT_PART_COMPONENT_ID)
          ?.partKey !== PartKey.MAT
    );

  if (drawerAccessories.length > 0) {
    removeProducts(drawerAccessories, coreApi, products);
    coreApi.getSystem<AccessoryAddedSystem>('AccessoryAddedSystem')?.removeClippingFromAllDrawers();
  }
};

export default removeAllDrawerAccessoriesFromScene;
